define('products_detail_later_cell.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('products_detail_later_cell', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"products-detail-later-cell\"><div data-type=\"backbone.collection.view.cell\"></div></div>  ";
},"useData":true}, 'extensions/SC/Threads/3.4.4/', 'extensions/SC/Threads/3.4.4/', Handlebars);
});